module.exports = __webpack_public_path__ + "static/img/chuzhongyingyu2.16d6b57c.jpg";